import { render, staticRenderFns } from "./CloseGoogle.vue?vue&type=template&id=3db15654&scoped=true&"
import script from "./CloseGoogle.vue?vue&type=script&lang=js&"
export * from "./CloseGoogle.vue?vue&type=script&lang=js&"
import style0 from "./CloseGoogle.vue?vue&type=style&index=0&id=3db15654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db15654",
  null
  
)

export default component.exports